import { connect } from 'react-redux';
import { denormalize } from 'normalizr';
import { schema } from '../../../../../state/schema';
import {
  loadJournalPartnerTagsAdmin,
  deleteJournalPartnerTagAdmin,
} from '../../../../../state/modules/journalPartnerTagsAdmin/actions';
import JournalPartnerTagsAdminList from '../components/JournalPartnerTagsAdminList';
import storage from '../../../../../lib/Storage';
import { findStorageType } from '../../../../../lib/Auth';

const mapStateToProps = (state, ownProps) => {
  const page = ownProps.page;
  const limit = ownProps.limit;
  const order = ownProps.order;
  const result = state.journalPartnerTagsAdmin.getIn([
    'pages',
    order,
    limit,
    page,
  ]);

  return {
    list: result
      ? result
          .map((x) => {
            return {
              key: x,
              ...denormalize(
                state.entities.getIn(['journalPartnerTagsAdmin', x]),
                schema.journalPartnerTagAdmin,
                state.entities.toJS()
              ),
            };
          })
          .toArray()
      : [],
    isLoading: state.journalPartnerTagsAdmin.get('isLoading'),
    total: state.journalPartnerTagsAdmin.get('total'),
    activeId: storage.get(findStorageType(), 'partnershipId'),
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    load: (parntershipId, page, limit, order, filter, cb) => {
      dispatch(
        loadJournalPartnerTagsAdmin(
          parntershipId,
          page,
          limit,
          order,
          filter,
          cb
        )
      );
    },
    remove: (partnershipId, id, cb) => {
      dispatch(deleteJournalPartnerTagAdmin(partnershipId, id, cb));
    },
  };
};

const JournalPartnerTagsAdminListContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(JournalPartnerTagsAdminList);

export default JournalPartnerTagsAdminListContainer;
